import { useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { syncPartnerDirectoryBadgeListings } from "@/app/services/partnerDirectoryApi.service";

export function useSyncBadgeListing() {
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, variables } = useMutation({
    mutationKey: ["admin", "badges", "listing-sync"],
    mutationFn: async (badgeId: number) => {
      const [outcome] = await syncPartnerDirectoryBadgeListings([badgeId]);
      return outcome;
    },
    onSuccess: (outcome) => {
      queryClient.invalidateQueries({ queryKey: ["admin", "badges"] });
      if (outcome?.status === "synced") {
        toaster.create({ title: "Store listing synced", type: "success" });
      } else if (outcome?.status === "failed") {
        toaster.create({ title: "Store listing sync failed", description: outcome.error.message, type: "error" });
      } else if (outcome?.status === "skipped" && outcome.reason === "in_progress") {
        toaster.create({ title: "A sync for this listing is already running", type: "info" });
      }
    },
    onError: (error: Error) => {
      toaster.create({ title: "Store listing sync failed", description: error.message, type: "error" });
    },
  });

  return { mutate, mutateAsync, isPending, syncingBadgeId: variables };
}
